module.exports = __webpack_public_path__ + "fonts/iconfont.a54c6083.ttf";